export default "__VITE_ASSET__uIaAyJKx__"